import Shader from '../../shader'
import {simpleShader} from '../../util'
import * as store from '../../store'

/**
 * @filter         Denoise
 * @description    Smooths over grainy noise in dark images using an 9x9 box filter
 *                 weighted by color intensity, similar to a bilateral filter.
 * @param exponent The exponent of the color intensity difference, should be greater
 *                 than zero. A value of zero just gives an 9x9 box blur and high values
 *                 give the original image, but ideal values are usually around 10-20.
 */
export default function(exponent) {
  var gl = store.get('gl')
  // Do a 9x9 bilateral box filter
  gl.denoise = gl.denoise || new Shader(null, '\
    uniform sampler2D texture;\
    uniform float exponent;\
    uniform float strength;\
    uniform vec2 texSize;\
    varying vec2 texCoord;\
    void main() {\
      vec4 center = texture2D(texture, texCoord);\
      vec4 color = vec4(0.0);\
      float total = 0.0;\
      for (float x = -4.0; x <= 4.0; x += 1.0) {\
        for (float y = -4.0; y <= 4.0; y += 1.0) {\
          vec4 sample = texture2D(texture, texCoord + vec2(x, y) / texSize);\
          float weight = 1.0 - abs(dot(sample.rgb - center.rgb, vec3(0.25)));\
          weight = pow(weight, exponent);\
          color += sample * weight;\
          total += weight;\
        }\
      }\
      gl_FragColor = color / total;\
    }\
  ');

  // Perform two iterations for stronger results
  for (var i = 0; i < 2; i++) {
    simpleShader.call(this, gl.denoise, {
      exponent: Math.max(0, exponent),
      texSize: [this.width, this.height]
    });
  }

  return this;
}



// WEBPACK FOOTER //
// ./src/filters/adjust/denoise.js